export function courseLimitsDisplay(minimum: number | null, maximum: number | null): string | null {
    if (minimum !== null && maximum !== null) {
        if (minimum === maximum) {
            return `Select exactly ${minimum} ${minimum === 1 ? 'course' : 'courses'}`
        }
        return `Select ${minimum}-${maximum} courses`
    }
    if (minimum !== null) {
        return `Select at least ${minimum} ${minimum === 1 ? 'course' : 'courses'}`
    }
    if (maximum !== null) {
        return `Select up to ${maximum} ${maximum === 1 ? 'course' : 'courses'}`
    }
    return null
}
